(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-variant-picker"] && !Shopify.designMode) return;
  try {
    class CardVariantPicker extends HTMLElement {
    connectedCallback() {
      this.productUrl = this.dataset.productUrl;
      this.product = this.dataset.product ? JSON.parse(this.dataset.product) : null;
      this.isBundleTarget = this.dataset.target === 'bundle';
      this.cartForm = this.querySelector('card-product-form-component form');
      this.selections = [];
      this.selectedValueIds = [];

      this.trigger = this.querySelector('[data-trigger]');
      this.addButton = this.querySelector('.card-variant-picker__add-button');
      this.triggerLabel = this.querySelector('.card-variant-picker__trigger-label');
      this.defaultLabel = this.triggerLabel ? this.triggerLabel.textContent : '';

      this.addEventListener('card-product-form:loading', this.onCartLoading.bind(this));
      this.addEventListener('card-product-form:added', this.onCartAdded.bind(this));
      this.addEventListener('card-product-form:error', this.onCartError.bind(this));

      if (!this.trigger) {
        this.bundleAddButton = this.querySelector('[data-bundle-add]');
        if (this.bundleAddButton) {
          this.bundleAddButton.addEventListener('click', this.onBundleAddClick.bind(this, this.bundleAddButton));
        }
        return;
      }

      this.availabilityCache = new Map();

      this.modal = this.querySelector('[data-modal]');
      this.header = this.querySelector('.card-variant-picker__header');
      this.overlay = this.querySelector('[data-overlay]');
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.panes = Array.from(this.querySelectorAll('[data-pane]'));
      this.optionTabs = Array.from(this.querySelectorAll('[data-option-tab]'));
      this.valueButtons = Array.from(this.querySelectorAll('[data-value]'));
      this.currentStep = 0;

      this.trigger.addEventListener('click', this.toggle.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this));
      this.querySelector('[data-close]').addEventListener('click', this.close.bind(this));

      this.valueButtons.forEach(function bindValue(button) {
        button.addEventListener('click', this.onValueClick.bind(this, button));
      }, this);

      this.querySelectorAll('[data-back]').forEach(function bindBack(button) {
        button.addEventListener('click', this.goBack.bind(this));
      }, this);

      this.optionTabs.forEach(function bindTab(tab, index) {
        tab.addEventListener('click', this.onTabClick.bind(this, index));
      }, this);
    }

    onBundleAddClick(button) {
      const variant = JSON.parse(button.dataset.variant);
      this.addToBundle(variant);
    }

    async onValueClick(button) {
      if (button.disabled) {
        return;
      }

      const step = parseInt(button.dataset.step, 10);
      this.selections[step] = button.dataset.value;
      this.selectedValueIds[step] = button.dataset.optionValueId;

      const isLastStep = step === this.panes.length - 1;
      if (!isLastStep) {
        this.showStep(step + 1);
        this.fetchAvailability();
        return;
      }

      let variant = button.dataset.variant ? JSON.parse(button.dataset.variant) : null;
      if (!variant) {
        variant = await this.fetchVariant();
      }

      if (!variant) {
        console.error('Card variant picker: could not resolve a variant for the selected options.', this.selections);
        return;
      }

      if (this.isBundleTarget) {
        if (this.addToBundle(variant)) {
          this.resetSteps();
          this.close();
        }
        return;
      }

      this.addToCart(variant);
    }

    async fetchVariant() {
      if (!this.productUrl) {
        return null;
      }

      this.setLoading(true);

      let variant = null;
      try {
        const optionValueIds = this.selectedValueIds.filter(Boolean);
        const url = new URL(this.productUrl, window.location.origin);
        url.searchParams.set('option_values', optionValueIds.join(','));
        url.searchParams.set('section_id', 'variant-data-helper');

        const res = await fetch(url.toString());
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const dataEl = doc.querySelector('#VariantData');
        variant = dataEl ? JSON.parse(dataEl.textContent) : null;
      } catch (error) {
        console.error(error);
      }

      this.setLoading(false);
      return variant;
    }

    addToBundle(variant) {
      const basket = document.querySelector('build-bundle-basket-component');
      if (!basket) {
        console.error('Build bundle: no build-bundle-basket-component found on the page.');
        return false;
      }

      variant.optionNames = this.product ? this.product.options : [];
      variant.productTitle = this.product ? this.product.title : null;
      variant.productImage = this.product ? this.product.featured_image : null;

      return basket.addItem(variant);
    }

    addToCart(variant) {
      this.resetSteps();
      this.close();
      this.cartForm.elements.namedItem('id').value = variant.id;
      this.cartForm.requestSubmit();
    }

    onCartLoading() {
      clearTimeout(this.buttonStateTimeout);
      delete this.addButton.dataset.state;
      this.setLoading(true);
      this.triggerLabel.textContent = this.dataset.i18nAdding;
    }

    onCartAdded() {
      this.setLoading(false);
      this.showButtonState('success', this.dataset.i18nAdded, 1200);
    }

    onCartError(event) {
      const res = event.detail;
      const message = (res && (res.description || res.message)) || this.dataset.i18nError;

      this.setLoading(false);
      this.showButtonState('error', message, 3000);
    }

    showButtonState(state, label, duration) {
      clearTimeout(this.buttonStateTimeout);
      this.addButton.dataset.state = state;
      this.triggerLabel.textContent = label;

      this.buttonStateTimeout = setTimeout(
        function resetButtonState() {
          delete this.addButton.dataset.state;
          this.triggerLabel.textContent = this.defaultLabel;
        }.bind(this),
        duration
      );
    }

    async fetchAvailability() {
      if (!this.productUrl) {
        return;
      }

      const optionValueIds = this.selectedValueIds.filter(Boolean);
      const cacheKey = optionValueIds.join(',');

      if (this.availabilityCache.has(cacheKey)) {
        this.applyAvailability(this.availabilityCache.get(cacheKey));
        return;
      }

      this.setLoading(true);

      let data = null;
      try {
        const url = new URL(this.productUrl, window.location.origin);
        url.searchParams.set('option_values', cacheKey);
        url.searchParams.set('section_id', 'variant-availability-helper');

        const res = await fetch(url.toString());
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const dataEl = doc.querySelector('#VariantAvailabilityData');
        data = dataEl ? JSON.parse(dataEl.textContent) : null;

        if (data) {
          this.availabilityCache.set(cacheKey, data);
        }
      } catch (error) {
        console.error(error);
      }

      this.applyAvailability(data);
      this.setLoading(false);
    }

    applyAvailability(data) {
      if (!data) {
        return;
      }

      const discontinued = this.dataset.discontinued === 'true';

      this.valueButtons.forEach(function updateButton(button) {
        const valueId = button.dataset.optionValueId;
        const isAvailable = Boolean(data[valueId]);
        button.dataset.available = String(isAvailable);
        button.disabled = !isAvailable;

        const stockText = button.querySelector('.card-variant-picker__value-stock-text');
        if (stockText) {
          if (isAvailable) {
            stockText.textContent = this.dataset.i18nInStock;
          } else if (discontinued) {
            stockText.textContent = this.dataset.i18nDiscontinued;
          } else {
            stockText.textContent = this.dataset.i18nSoldOut;
          }
        }
      }, this);
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      (this.valueButtons || []).forEach(function toggleButton(button) {
        button.disabled = isLoading || button.dataset.available === 'false';
      });
    }

    goBack() {
      if (this.currentStep > 0) {
        this.showStep(this.currentStep - 1);
      }
    }

    onTabClick(index) {
      if (index >= this.currentStep) {
        return;
      }

      this.selections.length = index;
      this.selectedValueIds.length = index;
      this.showStep(index);
    }

    showStep(index) {
      this.currentStep = index;

      this.panes.forEach(function togglePane(pane, i) {
        pane.hidden = i !== index;
      });

      this.optionTabs.forEach(function toggleTab(tab, i) {
        tab.classList.toggle('is-active', i === index);
        tab.classList.toggle('is-done', i < index);
      });

      const activePane = this.panes[index];
      if (activePane && this.triggerLabel) {
        this.triggerLabel.textContent = activePane.dataset.selectLabel;
      }
    }

    resetSteps() {
      this.selections = [];
      this.selectedValueIds = [];
      if (this.panes.length) {
        this.showStep(0);
      }
    }

    toggle() {
      if (this.hasAttribute('open')) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.setAttribute('open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.resetSteps();
      this.setHeaderOffset();
      this.modal.focus();
      this.lockScrollForMobile();
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    close() {
      this.removeAttribute('open');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      // NOTE WATERY: fjern vælgeren fra det øverste lag igen
      if (this.modal.hasAttribute('popover')) {
        try { this.modal.hidePopover(); } catch (e) {}
        this.modal.removeAttribute('popover');
      }
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
      this.trigger.focus();
    }

    lockScrollForMobile() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.body.style.overflow = 'hidden';
        // NOTE WATERY: læg vælgeren i browserens øverste lag, så den ikke fanges inde i slideren (iOS)
        if (typeof this.modal.showPopover === 'function') {
          this.modal.setAttribute('popover', 'manual');
          this.modal.showPopover();
        }
      }
    }

    setHeaderOffset() {
      const offset = this.header ? this.header.offsetHeight : 0;
      this.style.setProperty('--card-variant-picker-header-h', offset + 'px');
    }

    onKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }

    onDocumentClick(e) {
      if (this.contains(e.target)) {
        return;
      }

      this.close();
    }
  }

  if (!customElements.get('card-variant-picker-component')) {
    customElements.define('card-variant-picker-component', CardVariantPicker);
  }

  class CardProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    async onSubmit(event) {
      event.preventDefault();
      this.dispatch('loading');

      let response = null;
      let data = null;
      try {
        response = await fetch(`${this.form.action}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        data = await response.json();
      } catch (error) {
        console.error(error);
      }

      if (!response || !response.ok) {
        this.onError(data);
        return;
      }

      this.onAdded(data);
    }

    onAdded(data) {
      document.body.dispatchEvent(new CustomEvent('cartcount:update'));
      document.body.dispatchEvent(new CustomEvent('product:added', { detail: data }));
      document.body.dispatchEvent(new CustomEvent('quickshop-product:added', { detail: data }));

      const cart = document.querySelector('wdn-cart');
      if (cart) {
        cart.reloadCart(false, false);
      }

      this.dispatch('added', data);
    }

    onError(data) {
      // Legacy/unused, only replicating existing behavior
      document.body.dispatchEvent(new CustomEvent('cart:error', { detail: data }));
      this.dispatch('error', data);
    }

    dispatch(state, detail) {
      this.dispatchEvent(new CustomEvent(`card-product-form:${state}`, { bubbles: true, detail }));
    }
  }

  if (!customElements.get('card-product-form-component')) {
    customElements.define('card-product-form-component', CardProductForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-free-gift"] && !Shopify.designMode) return;
  try {
    class WDNCartGifts extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest('[data-cart-free-gift-container]');
      this.handleCartUpdate = this.onCartUpdate.bind(this);
    }

    connectedCallback() {
      document.addEventListener('cartlayout:updated', this.handleCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cartlayout:updated', this.handleCartUpdate);
    }

    async onCartUpdate(e) {
      const text = e.detail.cartResponseText;
      if (!text) {
        return;
      }
      const data = JSON.parse(text);
      const sections = data.sections || data;
      const cartDrawerSection = sections['cart-drawer'];
      const html = new DOMParser().parseFromString(cartDrawerSection, 'text/html');
      const container = html.querySelector('[data-cart-free-gift-container]');
      if (!container) {
        return;
      }
      this.container.replaceWith(container);
      this.container = container;
    }
  }

  if (!customElements.get('wdn-cart-gifts')) {
    customElements.define('wdn-cart-gifts', WDNCartGifts);
  }

  class WDNCartGiftItem extends HTMLElement {
    constructor() {
      super();

      this.WDNCart = document.querySelector('wdn-cart');

      this.submitBtn = this.querySelector('button[data-name="gift_update"]');
      this.lineId = this.getAttribute('data-line-id');
      this.giftStatus = this.getAttribute('data-gift-status');
      this.handleAdd = this.onGiftClick.bind(this);
    }

    connectedCallback() {
      this.submitBtn?.addEventListener('click', this.handleAdd);
      if (this.giftStatus == 'invalid') {
        this.removeFromCart();
      }
    }

    disconnectedCallback() {
      this.submitBtn?.removeEventListener('click', this.handleAdd);
    }

    onGiftClick() {
      if (this.giftStatus !== 'unlocked') {
        return;
      }
      this.addToCart();
    }

    async addToCart() {
      await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: this.lineId,
              quantity: 1,
              properties: {
                _isFreeGift: 'yes',
              },
            },
          ],
        }),
      });

      this.WDNCart?.reloadCart();
    }

    async removeFromCart() {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.lineId,
          quantity: 0,
        }),
      });

      this.WDNCart?.reloadCart();
    }
  }

  if (!customElements.get('wdn-gift-item')) {
    customElements.define('wdn-gift-item', WDNCartGiftItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-description-modal"] && !Shopify.designMode) return;
  try {
    class ProductCardDescription extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.modal = this.querySelector('wdn-modal');
      if (!this.modal) return;

      this.onModalOpened = this.handleModalOpened.bind(this);
      document.body.addEventListener('overlay:opened', this.onModalOpened);
    }

    disconnectedCallback() {
      document.body.removeEventListener('overlay:opened', this.onModalOpened);
      if (this.modal?.isActive) this.modal.close();
    }

    handleModalOpened(event) {
      if (event.detail !== this.modal) return;
      this.load();
    }

    async load() {
      if (this.loaded || this.loading) return;

      const output = this.modal?.querySelector('[data-product-description-output]');
      if (!output) return;

      this.loading = true;
      this.loaded = false;
      output.setAttribute('aria-busy', 'true');
      output.innerHTML = `
        <div class="product-card-description__loading" role="status">
          <span class="product-card-description__spinner" aria-hidden="true"></span>
        </div>
      `;

      try {
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', 'product-description-helper');
        const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        output.innerHTML = await response.text();
        this.loaded = true;
      } catch (error) {
        output.innerHTML = `
          <div class="product-card-description__error" role="alert">
            <p>${this.escapeHtml(this.dataset.loadError)}</p>
          </div>
        `;
      } finally {
        this.loading = false;
        output.removeAttribute('aria-busy');
      }
    }

    escapeHtml(value) {
      const element = document.createElement('div');
      element.textContent = value || '';
      return element.innerHTML;
    }
  }

  if (!customElements.get('product-card-description')) {
    customElements.define('product-card-description', ProductCardDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["replace_non_responsive_tables"] && !Shopify.designMode) return;
  try {
    class ResponsiveTable extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.responsive-table');

      if (!this.scroller) return;

      this.update = this.update.bind(this);

      this.scroller.addEventListener('scroll', this.update, {
        passive: true,
      });

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.scroller);

      const table = this.scroller.querySelector('table');
      if (table) this.resizeObserver.observe(table);

      this.update();
    }

    disconnectedCallback() {
      this.scroller?.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }

    update() {
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;

      const hasMore = maxScroll > 1 && this.scroller.scrollLeft < maxScroll - 1;

      this.classList.toggle('has-more', hasMore);
    }
  }

  if (!customElements.get('responsive-table-component')) {
    customElements.define('responsive-table-component', ResponsiveTable);
  }
  } catch(e) { console.error(e); }
})();

})();
